class VehicleConditionalFilters {
  constructor() {
    this.elements = [...document.querySelectorAll('[data-visible-conditions]')];
    this.init();
  }

  /**
   * Initialise elements
   */
  init() {
    this.elements.forEach(element => {
      try {
        const conditions = JSON.parse(element.dataset.visibleConditions) ?? [];
        if (Array.isArray(conditions)) element.conditions = conditions;
      } catch (error) {
        console.error('Error parsing visible conditions:', error);
        return;
      }
    });
  }

  /**
   * Form field visibility evaluator
   * @param {[string, any][]} form current form fields
   */
  evaluateConditions(form) {
    this.elements.forEach(element => {
      const { conditions } = element;
      const matches = [];
      for (let { field, value } of conditions) {
        matches.push(...form.filter(([key, option]) => key === field && option === value));
      }
      element.classList.toggle('hide', matches.length < 1);
    });
  }
}

export { VehicleConditionalFilters };
